// Black Diamond roles
export const BLACK_DIAMOND_ROLE = 'BlackDiamond';
export const DC_MANAGED_VIP_ROLE = 'DC:ManagedVIP';

export const RUBY_TIER_ACHIEVED_REWARD = 'ruby-tier-achieved';

export enum TIER_CODES {
    SILVER = 'silver',
    GOLD = 'gold',
    PLATINUM = 'platinum',
    DIAMOND = 'diamond',
    EMERALD = 'emerald',
    RUBY = 'ruby',
    BLACK_DIAMOND = 'black-diamond',
};

export enum TIER_LEVELS  {
    SILVER = 0,
    GOLD = 1,
    PLATINUM = 2,
    DIAMOND = 3,
    EMERALD = 4,
    RUBY = 5,
    BLACK_DIAMOND = 6,
};
